var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcStep6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Step 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile---use-case-2---autofill-scroll",
    transform: "translate(-20.000000, -446.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(20.000000, -310.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(0.000000, 756.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.15,
    cx: 10,
    cy: 10,
    r: 10
  }), /*#__PURE__*/React.createElement("text", {
    id: 6,
    fontFamily: "AmazonEmber-Regular, Amazon Ember",
    fontSize: 14,
    fontWeight: "normal",
    textAnchor: "middle",
    dominantBaseline: "central",
    x: 10,
    y: 10
  }, "6")))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStep6);
export default __webpack_public_path__ + "static/media/ic_step_6.001e925c553a23abe010c968a11f2c11.svg";
export { ForwardRef as ReactComponent };